import { BulkExecutionError } from './../models/bulk-execution-error.model';
import { AuthService } from './auth.service';
import { Owner } from './../models/owner.model';
import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { UtilsService } from 'src/app/services/utils.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
  providedIn: 'root'
})
export class OwnersService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
        private authService: AuthService
    ) { }

    getOwners(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/propietarios';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Owner[]>(url, { headers, observe: 'response', params });
    }

    getOwnerById(id: ID) {
        return this.http.get<Owner>(`/propietarios/${id}`);
    }

    deleteOwner(ownerId: ID) {
        return this.http.delete(`/propietarios/${ownerId}`);
    }

    createOwner(owner: Owner) {
        return this.http.post<Owner>(`/propietarios`, owner);
    }

    editOwner(owner: Owner) {
        return this.http.put<Owner>(`/propietarios/${owner.id}`, owner);
    }

    searchOwner(query: string) {
        const params = { query };
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        return this.http.get<Owner[]>(`/propietarios/busqueda`, { params });
    }

    bulkLoad(owners: Owner[]) {
        return this.http.post<BulkExecutionError[]>(`/propietarios/creacion-masiva`, owners);
    }

    isAvailable(key: string, value: any) {
        return this.http.post<{ disponible: boolean }>(`/propietarios/disponibilidad`, { campo: key, valor: value });
    }
}
